/* eslint-disable @typescript-eslint/no-explicit-any */
import ConfirmationModal from 'components/modal/ConfirmationModal';
import interactivePromise from '@tock/shared/utils/interactivePromise';

export interface ConfirmOptions {
  cancelText?: string;
  continueText?: string;
  isDestructive?: boolean;
  title?: string;
}

const confirm = {
  onTransition(text: any) {
    return confirm.show(text);
  },

  show(text: any, options: ConfirmOptions = {}) {
    const props = {
      cancelText: options.cancelText,
      continueText: options.continueText,
      isDestructive: options.isDestructive,
      text,
      title: options.title,
    };

    return interactivePromise<void>((resolve, reject) => (
      <ConfirmationModal
        cancelText={props.cancelText}
        continueText={props.continueText}
        isDestructive={props.isDestructive}
        onCancel={reject}
        onContinue={resolve}
        text={props.text}
        title={props.title}
      />
    ));
  },
};

export default confirm;
